import { createContext, useContext, useState, useEffect } from 'react';
import { googleLogout } from '@react-oauth/google';
import axios from 'axios';
import API_URL from '../config/api';
import { getSubdomain } from '../hooks/subdomainConfig.js';
const AuthContext = createContext();
const subdomain = getSubdomain();
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [employee, setEmployee ] = useState(null);
  const [loading, setLoading] = useState(true);
  const [canOnboard, setCanOnboard] = useState(false);
  const subdomain = getSubdomain();
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await axios.get(`${API_URL}/api/auth/verify`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {subdomain: subdomain}
      });

      if (response.data.success) {
        setUser(response.data.user);
        setCanOnboard(response.data.canOnboard);
        setEmployee(response.data.employeeData);
      } else {
        localStorage.removeItem('authToken');
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
    } finally {
      setLoading(false);
    }
  };

  const loginWithGoogle = async (credentialResponse) => {
    try {
      const response = await axios.post(`${API_URL}/api/auth/google`, {
        credential: credentialResponse.credential,
        subdomain: subdomain
      });

      if (response.data.success) {
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        setUser(response.data.user);
        setCanOnboard(response.data.canOnboard);
        setEmployee(response.data.employeeData);
        return { success: true, canOnboard: response.data.canOnboard };
      } else {
        return { success: false, error: response.data.error };
      }
    } catch (error) {
      console.error('Login error:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Login failed' 
      };
    }
  };

  const logout = () => {
    googleLogout();
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setUser(null);
    setEmployee(null);
    setCanOnboard(false);
    window.location.href= '/login';
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      loading, 
      canOnboard, 
      loginWithGoogle, 
      logout,
      employee,
      isAuthenticated: !!user 
    }}>
      {children}
    </AuthContext.Provider>
  );
};